import {
  basicLogger,
  initialize as initializeLd,
} from "launchdarkly-js-client-sdk";

// client version of this plugin uses the client (browser) SDK. The server
// version of this plugin uses the node client SDK.
export default defineNuxtPlugin({
  name: "launchdarkly",
  dependsOn: ["session"],
  async setup(_nuxtApp) {
    const logger = useAppLogger("launchdarkly:client");
    const config = useRuntimeConfig();
    if (!config.public.launchDarkly.clientSideId) return;

    const context = useLdContext();
    const ldClient = initializeLd(
      config.public.launchDarkly.clientSideId,
      context.value,
      {
        logger: basicLogger({ level: "warn" }),
      },
    );
    try {
      await ldClient.waitForInitialization(5);
      setLdClient(ldClient);
    } catch (e) {
      logger.error("LaunchDarkly client failed to initialize", e);
    }

    watch(context, () => {
      ldClient?.identify(context.value);
    });
  },
});
